/**
 * 函数节流, 一次执行完成之后才能进行下一次执行
 */

// eslint-disable-next-line import/prefer-default-export
export function throttle(func, time) {
  var prevTime = null;
  var timer = null;
  return function () {
    var arguments$1 = arguments;
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments$1[_i];
    }

    timer && clearTimeout(timer);
    var current = Date.now(); // 首次访问的时候prevTime取当前时间

    prevTime = prevTime || current;

    if (current - prevTime > time) {
      func.apply(void 0, args);
      prevTime = current;
    } else {
      timer = window.setTimeout(function () {
        func.apply(void 0, args);
        prevTime = null; // 成功请求时间重新计算
      }, time);
    }
  };
}